<!-- Backdrop -->
<div 
  class="menu-backdrop" 
  *ngIf="isOpen"
  [@backdropFade]="getAnimationState()"
  (click)="onBackdropClick()">
</div>

<!-- Menu Panel -->
<div 
  class="menu-panel" 
  *ngIf="isOpen"
  [@slideUpDown]="getAnimationState()">
  
  <div class="menu-header">
    <div class="menu-title">Menu</div>
    <button class="close-button" (click)="onBackdropClick()" aria-label="Close menu">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div class="menu-content">
    <div class="menu-items">
      <ng-container *ngFor="let item of menuItems">
        
        <!-- External link -->
        <a 
          *ngIf="item.external && item.href; else internalLink"
          [href]="item.href"
          target="_blank"
          rel="noopener noreferrer"
          class="menu-item"
          (click)="onMenuItemClick()">
          <span class="menu-item-text">{{ item.label }}</span>
        </a>

        <!-- Internal link template -->
        <ng-template #internalLink>
          <a 
            [routerLink]="item.target" 
            [fragment]="item.fragment"
            class="menu-item"
            (click)="onMenuItemClick()">
            <span class="menu-item-text">{{ item.label }}</span>
          </a>
        </ng-template>

      </ng-container>
    </div>

    <div class="menu-footer">
      <a 
        class="login-button" 
        href="https://admin.hostelhop.io/#/login" 
        target="_blank"
        rel="noopener noreferrer"
        (click)="onMenuItemClick()">
        <span>Login/Register</span>
      </a>
    </div>
  </div>
</div>
